<template>
  <spinner class="vz-loading-spinner" :active="active" />
</template>

<script>
import Spinner from '@/components/molecules/page-loading-spinner';

export default {
  name: 'LoadingSpinner',
  components: {
    Spinner
  },

  data: () => ({
    active: false
  }),

  methods: {
    start() {
      this.active = true;
    },

    finish() {
      this.active = false;
    }
  }
};
</script>
